import { render, staticRenderFns } from "./PageHeaderLogo.vue?vue&type=template&id=24edb6fd&scoped=true&"
import script from "./PageHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./PageHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderLogo.vue?vue&type=style&index=0&id=24edb6fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edb6fd",
  null
  
)

export default component.exports